const slug = require('slug');
const locales = require('./utility/locales');
const pages = require('./utility/pages');

// eslint-disable-next-line
const EMAIL_REGEX = new RegExp(`^[a-zA-Z0-9.!#$%&'*+\/=?^_\`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$`);

//TODO check
const gtag = (...args) => {
    if (window.datalayer) {
        window.datalayer.push(...args);
    }
}

//TODO check
const trackOutboundLink = (url, action, category) => {
    gtag('event', action, {
        'event_category': category,
        'event_label': url,
        'transport_type': 'beacon'
    });
}

slug.defaults.modes['pretty'] = {
    replacement: '-',
    symbols: true,
    remove: /[.]/g,
    lower: true,
    charmap: slug.charmap,
    multicharmap: slug.multicharmap
};
slug.defaults.mode ='pretty';

const slugify = text => {
    if (text){
        return slug(text);
    }
}

const formatPrice = (amount, currency) => {
    let price = (amount / 100).toFixed(2);
    let numberFormat = new Intl.NumberFormat(["it-IT"], {
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol",
    });
    return numberFormat.format(price)
}

const mapLocalized = (data, locale) => {
    return Object.keys(data).reduce((obj, key) => {
        obj[key] = findLocalized(data[key], locale);
        return obj;
    }, {});
}

const filterLocalized = (data, locale) => {
    return Object.keys(data).reduce((obj, key) => {
        obj[key] = filterLocalizedField(data[key], locale);
        return obj;
    }, {});
}

const filterLocalizedField = (field, locale) => {
    const localizedEdges = field.edges.filter(edge => edge.node.lang === locale);
    return localizedEdges ? localizedEdges.map(edge => edge.node) : [];
}

const findLocalized = (field, locale) => {
    if (!field.edges) return field;
    const localizedEdge = field.edges.find(edge => edge.node.lang === locale);
    return localizedEdge ? localizedEdge.node : null;
}

const translatePage = (page, locale = 'it') => {
    if (locales[locale].default){
        return page;
    }
    const translatedPage = pages[locale](page);
    if (translatedPage){
        return `/${locales[locale].path}${translatedPage}`;
    }
    return page;
}

module.exports = {
    trackOutboundLink,
    slugify,
    formatPrice,
    gtag,
    mapLocalized,
    filterLocalized,
    findLocalized,
    filterLocalizedField,
    translatePage,
    EMAIL_REGEX
}